// extracted by mini-css-extract-plugin
export default {"mainContainer":"LayoutPage_mainContainer__nnJk+"};